import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import { name as appModuleName } from '@/store/modules/app';
import { name as userModuleName } from '@/store/modules/user';
import requestStatus from '@/utils/constants/requestStatus';
import types from '@/store/modules/app/types';
import roles from '@/utils/constants/roles.js';
const EDIT_CASE_ROUTE_NAME = 'editRequest';
const HOME_ROUTE_NAME = 'main';
const NEW_CASE_ROUTE_NAME = 'createRequest';
const ON_CHANGE_CASE_LIST_EVENT_LISTENER_NAME = 'on-change-case-list';

export const utilityMixin = {
  computed: {
    ...mapGetters(appModuleName, {
      itemModel: 'getItemModel',
      sidebarBadgeCount: 'getSidebarBadgeTotals',
      isMobile: 'getIsMobileDensity',
    }),
    ...mapState(appModuleName, ['isCaseListOpen']),
    isNewCaseMode() {
      return this.$route.name === NEW_CASE_ROUTE_NAME;
    },
    isEditMode() {
      return this.$route.name === EDIT_CASE_ROUTE_NAME;
    },
    canViewActionSideBar() {
      console.log(this.itemModel?.requestStatusId)
      console.log(requestStatus.Nuevo)
      return (
        (!!this.itemModel?.requestStatusId &&
          this.itemModel.requestStatusId !== requestStatus.Nuevo) || this.roleName()?.toLowerCase() != roles.APPLICANT.toLowerCase()
      );
    },
    canViewChangeStatusSideBar() {

      return true;
    },
    canViewAssignmentManagementSideBar() {
      return (
       
        !!this.itemModel?.requestStatusId &&
        (this.itemModel.requestStatusId == requestStatus.EnProceso ||
          this.itemModel.requestStatusId == requestStatus.Sometida ||
          this.itemModel.requestStatusId ==
          requestStatus.DevueltoPorFaltaInformacion ||
          this.itemModel.requestStatusId == requestStatus.RedaccionCarta ||
          this.itemModel.requestStatusId == requestStatus.Autorizado ||
          this.itemModel.requestStatusId == requestStatus.DocumentoTesis)
      );
    },
    isMain() {
      return this.$route.name === HOME_ROUTE_NAME;
    },
    isCaseResolved() {
      return this.itemModel.isLastStep;
    },
    canManageStatus() {
      return this.itemModel.canManageStatus;
    },
    selectedRequestNumber() {
      return this.itemModel.requestNumber;
    },
  },
  methods: {
    ...mapActions(appModuleName, ['getBadgeCount']),
    ...mapMutations(appModuleName, [
      'setIsNavOpen',
      'setRefreshCaseInfo',
      'disposeCaseInfo',
      'setSidebarBadges',
      'setOpenCaseList',
      'setRefreshCaseList',
      types.SET_ITEM_MODEL,
    ]),
    ... mapGetters(userModuleName, {
      roleName: 'role',
    }),
    triggerOnChangeCaseListEvent() {
      this.$event.$emit(ON_CHANGE_CASE_LIST_EVENT_LISTENER_NAME);
    },
  },
};
